import React from "react";
import { Modal, Col } from "reactstrap";
import { CustomButton } from "../home/main/home-layout-draggable-columns/custom-button";
import WarningIcon from "./items/WarningIcon";

export const ModalPublishAlert = ({ onCancel, isOpen }) => (
  <Modal isOpen={isOpen} className="modal-dialog-centered confirm-remove-modal">
    <div className="publish-modal-header">
      <div>
        <WarningIcon />
      </div>
      <div className="publish-modal-message">
      You need to setup your Appstore Information. On the top Menu Tap Appstore Info and fill all required fields.
      </div>
    </div>
    <div className="publish-modal-buttons">
    <Col xs="14">
      <CustomButton type="SAVE" onClick={onCancel} label="OK" />
      </Col>      
    </div>
  </Modal>
);
